import { render } from "./AddEstimateItemModal.vue?vue&type=template&id=0bf082a2"
import script from "./AddEstimateItemModal.vue?vue&type=script&lang=js"
export * from "./AddEstimateItemModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/environment/links-frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__